import React, { useState, useEffect } from 'react';
import  Select  from '@mui/material/Select';
import MenuItem  from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';

import { getAllRoles } from '../../api/authenticateAPIs';
import { useTranslation } from 'react-i18next';

export default function RoleSelectBox({ selectValue, onChange }) {

    const [t] = useTranslation('global');
    const [roles, setRoles] = useState([]);

    useEffect(() => {
        getAllRoles()
        .then((data) => {
            setRoles(data);
        })   
    },[]);

  return (
    <div>
        <label htmlFor="roleId">{t('role')}</label>
        <FormControl className='role-formcontrol'>
            {selectValue === '' && 
                <InputLabel id="role-select" shrink={false}>Select</InputLabel>
            }
            <Select 
                id='roleId'
                name='roleId'
                labelId='role-select'
                className='role-selectbox'
                value={selectValue}
                onChange={onChange}
                sx={{
                    "& fieldset": {
                      border: "none",
                    },
                }}
            >
                {roles.map((role, index) => (
                <MenuItem key={index} value={role.id}>
                    {role.name}
                </MenuItem>))}
            </Select>
        </FormControl>
    </div>
  );
}